// Returns access for budget upload based on
//   BudgetUnit.actionsOnBudgetItems PolicyActions

import { useMemo } from 'react';
import * as R from 'ramda';

import { usePreferences } from '@atom/hooks/usePreferences';
import { PolicyAction } from '@atom/types/policy';
import { hasAccess } from '@atom/utilities/accessUtilities';

export const useBudgetBulkEditAccess = (actions: PolicyAction[]) => {
  const preferences = usePreferences();

  const showAuthorizedBudget = R.pathOr(
    false,
    ['budgeting', 'showAuthorizedBudget'],
    preferences,
  );

  const hasBulkEditBudgetItemAccess = hasAccess(
    PolicyAction.BULK_EDIT_BUDGET_ITEM,
    actions,
  );

  const hasBulkEditAuthorizedBudgetAccess = hasAccess(
    PolicyAction.BULK_EDIT_AUTHORIZED_BUDGET,
    actions,
  );

  const canUpload = useMemo(() => {
    return !showAuthorizedBudget
      ? hasBulkEditBudgetItemAccess
      : hasBulkEditBudgetItemAccess || hasBulkEditAuthorizedBudgetAccess;
  }, [actions]);

  return {
    canUpload,
    hasBulkEditBudgetItemAccess,
    hasBulkEditAuthorizedBudgetAccess,
  };
};
